import { useScrollReveal } from "../useScrollReveal";
import "./Es3Deal.css";

function Es3Deal() {
  const { ref, fromDir, fromRight } = useScrollReveal(0.1);

  return (
    <section className="es3-section es3-deal" id="es3-deal" ref={ref}>
      <div className="es3-deal-grid">
        <div className="es3-deal-left" style={fromDir(0)}>
          <div className="es3-hand">the deal</div>
          <p className="es3-deal-big">
            <b>You bring it.</b> We hang it. <b>It sells.</b> You get paid.
          </p>
        </div>
        <div className="es3-prose es3-deal-right" style={fromRight(160)}>
          <p>
            Tell us what you make and the story behind it. If it is right for the drop, it comes to <strong>DD Block, DHA Phase 4</strong> and gets treated the way work should be treated: framed on a wall, raised on a plinth, held in a steel grid, or spotlit on a shelf. Beside it, a small gallery label with your name, your story and your price.
          </p>
          <p>
            When your piece finds its person, the money reaches you fast and clean. <strong>You keep the majority of every sale.</strong> Our share keeps the lights warm, the coffee hot and the room open for the next maker.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Es3Deal;
